import { state } from "./state.js";
import { setStatus, setLogo, debuggPrint, setInfoText } from "./dom/layout.js";
import { setSession, updateRanking, clearAll, setRemainingTime } from "./session.js";

function forceReload() {
  location.reload();
}

export function startReconnect() {
  setTimeout(connectToWs, 1000);
}

export function connectToWs() {
  try {
    if (typeof MozWebSocket === "function") window.WebSocket = MozWebSocket;
    state.websocket = new WebSocket(state.configJSON.Server + ":" + state.configJSON.Port);

    state.websocket.onopen = () => {
      console.log("CONNECTED");
      setStatus("CONNECTED");
      state.websocket.send(`{"chanel":${state.configJSON.Chanel}}`);
    };

    state.websocket.onclose = () => {
      console.log("DISCONNECTED");
      setStatus("DISCONNECTED");
      startReconnect();
    };

    state.websocket.onmessage = (evt) => {
      debuggPrint("Message received: " + evt.data);
      evaluateData(evt.data);
    };

    state.websocket.onerror = (evt) => {
      console.log("ERROR: " + evt);
    };
  } catch (exception) {
    console.log("ERROR CATCH: " + exception);
    startReconnect();
  }
}

export function evaluateData(data) {
  const dataJSON = JSON.parse(data);
  switch (dataJSON.TelegrammType) {
    case "all":
      setSession(dataJSON);
      updateRanking(dataJSON);
      setInfoText(dataJSON.InfoText);
      break;
    case "system":
      break;
    case "logo":
      setLogo(dataJSON.Logo);
      break;
    case "clearAll":
      clearAll();
      break;
    case "remainingTime":
      setRemainingTime(dataJSON.Time);
      break;
    case "ForceReload":
      forceReload();
      break;
    default:
      debuggPrint("Unknown TelegrammType");
  }
}
